import script from "./NLSearchTestPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NLSearchTestPanel.vue?vue&type=script&setup=true&lang=js"

import "./NLSearchTestPanel.vue?vue&type=style&index=0&id=638d0a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638d0a88"]])

export default __exports__